import React from 'react';
import { Globe } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-950 px-4 border-t border-white/5 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-117">
      <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-pink-500/5 blur-3xl rounded-full" data-id="element-118"></div>
      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-119">
        <div className="flex items-center justify-center space-x-3 text-pink-400 font-serif font-bold text-3xl mb-8 tracking-tighter" data-id="element-120">
          <Globe className="w-8 h-8" data-id="element-121" />
          <span className="font-[800] font-[Montserrat,_sans-serif]" data-id="element-122">
            MUNDO PRÁCTICO™
          </span>
        </div>

        <div className="max-w-xl mx-auto mb-16" data-id="element-123">
          <p className="text-white text-lg md:text-xl font-sans font-medium mb-4 opacity-90" data-id="element-124">
            El sistema de gestión de reservas N°1 para profesionales de belleza
            independientes en Argentina.
          </p>
          <p className="text-pink-200/60 font-bold uppercase tracking-[0.2em] text-[10px] md:text-xs font-sans" data-id="element-125">
            Porque trabajar bien no debería ser suficiente razón para seguir
            perdiendo plata con cada turno que se cae.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 text-sm font-bold uppercase tracking-widest text-gray-400 mb-20 font-sans" data-id="element-126">
          <a href="mailto:mundopractico.oficial@gmail.com" className="hover:text-pink-400 transition-all duration-300 flex items-center" data-id="element-127">
            <span className="mr-3" data-id="element-128">📧</span> mundopractico.oficial@gmail.com
          </a>
          <span className="hidden md:block w-px h-4 bg-white/10" data-id="element-129"></span>
          <a href="https://mundopractico.online" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-all duration-300 flex items-center" data-id="element-130">
            <span className="mr-3" data-id="element-131">🌐</span> mundopractico.online
          </a>
        </div>

        <div className="border-t border-white/5 pt-12 flex flex-col items-center" data-id="element-132">
          <p className="text-[10px] md:text-xs text-gray-500 mb-10 tracking-widest uppercase font-bold max-w-2xl leading-relaxed opacity-60 font-sans" data-id="element-133">
            © Mundo Práctico™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <div className="relative cursor-default" data-id="element-134">
            <p className="text-pink-400 font-sans font-medium text-xl md:text-2xl relative z-10 tracking-tight" data-id="element-135">
              "La próxima consulta que llegue puede terminar en turno confirmado
              con seña del otro lado."
            </p>
            <p className="text-pink-200/40 font-bold uppercase tracking-[0.3em] text-[10px] mt-4 font-sans" data-id="element-136">
              MUNDO PRÁCTICO™
            </p>
          </div>
        </div>
      </div>
    </footer>;
};